(function () {
  function getAttributeSelectorValue(value) {
    return value.replace(/["\\]/g, "\\$&");
  }

  function getTargetFromHash(hash) {
    if (!hash || hash === "#") {
      return null;
    }

    var id = "";

    try {
      id = decodeURIComponent(hash.slice(1));
    } catch (error) {
      id = hash.slice(1);
    }

    if (!id) {
      return null;
    }

    return (
      document.getElementById(id) ||
      document.querySelector('[name="' + getAttributeSelectorValue(id) + '"]')
    );
  }

  function getScrollMarginTop(element) {
    var value = window.getComputedStyle(element).scrollMarginTop;
    var offset = parseFloat(value);

    return Number.isFinite(offset) ? offset : 0;
  }

  function shouldHandleClick(event, link) {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      link.hasAttribute("download") ||
      link.dataset.noSmoothScroll !== undefined
    ) {
      return false;
    }

    var target = link.getAttribute("target");

    return !target || target === "_self";
  }

  document.addEventListener("click", function (event) {
    if (!(event.target instanceof Element)) {
      return;
    }

    var link = event.target.closest('a[href*="#"]');

    if (!link || !shouldHandleClick(event, link)) {
      return;
    }

    var url;

    try {
      url = new URL(link.href, window.location.href);
    } catch (error) {
      return;
    }

    if (
      url.origin !== window.location.origin ||
      url.pathname !== window.location.pathname ||
      url.search !== window.location.search
    ) {
      return;
    }

    var target = getTargetFromHash(url.hash);

    if (!target) {
      return;
    }

    event.preventDefault();

    var behavior = window.matchMedia("(prefers-reduced-motion: reduce)").matches
      ? "auto"
      : "smooth";
    var top =
      target.getBoundingClientRect().top +
      window.pageYOffset -
      getScrollMarginTop(target);

    window.scrollTo({
      top: Math.max(0, top),
      behavior: behavior,
    });

    if (window.history && typeof window.history.pushState === "function") {
      window.history.pushState(null, "", url.hash);
    }
  });

  // ------------------------------------------------------------------------------------------
  // SC Vollbehandlung purchase-option picker (A/B DEV-3977)
  // Delegated and fieldset-scoped, so this stays inert on every page where the block is absent
  // (assets load globally). The radio toggle is the ONLY place that enables/disables the hidden
  // selling_plan input; the variant:changed handler never enables it (P2).
  // ------------------------------------------------------------------------------------------
  var SC_VB_ROOT = "sc-vollbehandlung";
  var SC_VB_PRICES_ATTR = "data-sc-vollbehandlung-prices";

  function scVbReadPrices(fieldset) {
    var script = fieldset.querySelector("[" + SC_VB_PRICES_ATTR + "]");

    if (!script) {
      return null;
    }

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  function scVbUpdateFieldset(fieldset, variantId) {
    var prices = scVbReadPrices(fieldset);

    if (!prices) {
      return;
    }

    var entry = prices[variantId];
    var subRadio = fieldset.querySelector('input[value="subscription"]');
    var subOption = subRadio ? subRadio.closest(".sc-vollbehandlung__option") : null;
    var hidden = fieldset.querySelector(".sc-vollbehandlung__plan");

    if (!entry) {
      // B4: no single selling plan for this variant. Force one-time so we never submit a plan
      // id for a plan-less variant, and hide the subscription option.
      if (subOption) {
        subOption.hidden = true;
      }

      var onetimeRadio = fieldset.querySelector('input[value="onetime"]');

      if (onetimeRadio) {
        onetimeRadio.checked = true;
      }

      if (hidden) {
        hidden.disabled = true;
      }

      fieldset.setAttribute("data-sc-plan", "onetime");
      return;
    }

    // P3: re-show the subscription option in case a previous variant hid it.
    if (subOption) {
      subOption.hidden = false;
    }

    var onetimeEl = fieldset.querySelector(".sc-vollbehandlung__price-onetime");
    var subEl = fieldset.querySelector(".sc-vollbehandlung__price-sub");
    var compareEl = fieldset.querySelector(".sc-vollbehandlung__price-compare");
    var perDeliveryEl = fieldset.querySelector(".sc-vollbehandlung__price-perdelivery");

    // Total-price switch: data-sc-total (rendered from the block setting) picks whether the main
    // price spans show the per-delivery values or the pre-computed cure totals.
    var useTotal = fieldset.getAttribute("data-sc-total") === "true";
    var subVal = useTotal ? entry.subTotal : entry.sub;
    var compareVal = useTotal ? entry.compareTotal : entry.compare;

    // Money strings arrive pre-formatted from Liquid and can contain markup, so set innerHTML
    // to match how the theme injects price markup.
    if (onetimeEl && entry.onetime != null) {
      onetimeEl.innerHTML = entry.onetime;
    }

    if (subEl && subVal != null) {
      subEl.innerHTML = subVal;
    }

    // Per-delivery line only exists in total mode; always shows the per-delivery value.
    if (perDeliveryEl && entry.sub != null) {
      perDeliveryEl.innerHTML = entry.sub;
    }

    // P5: honour showCompare from the JSON.
    if (compareEl) {
      if (entry.showCompare && compareVal != null) {
        compareEl.innerHTML = compareVal;
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }

    // B6: plan id per variant, never hardcoded. P2: do NOT touch hidden.disabled here.
    if (hidden) {
      hidden.value = entry.planId;
    }
  }

  document.addEventListener("change", function (event) {
    if (!(event.target instanceof Element)) {
      return;
    }

    var radio = event.target.closest('input[name^="sc-vollbehandlung-choice"]');

    if (!radio) {
      return;
    }

    var fieldset = radio.closest("." + SC_VB_ROOT);

    if (!fieldset) {
      return;
    }

    var hidden = fieldset.querySelector(".sc-vollbehandlung__plan");
    var isSubscription = radio.value === "subscription";

    fieldset.setAttribute("data-sc-plan", isSubscription ? "subscription" : "onetime");

    if (hidden) {
      hidden.disabled = !isSubscription;
    }
  });

  document.addEventListener("variant:changed", function (event) {
    // Payloads vary: some dispatchers send only { variant: { id } }, others variant: null.
    if (!event.detail || !event.detail.variant || event.detail.variant.id == null) {
      return;
    }

    var variantId = String(event.detail.variant.id);
    var fieldsets = document.querySelectorAll("." + SC_VB_ROOT);

    for (var i = 0; i < fieldsets.length; i++) {
      scVbUpdateFieldset(fieldsets[i], variantId);
    }
  });

  // Safety guard: if our block and the Recharge widget are ever both enabled, two
  // name="selling_plan" inputs would ride the same form and the wrong one could win silently.
  // On submit (capture phase), when the submitted form owns our hidden input via form=
  // association, disable every other selling_plan control so only ours submits. Our own input is
  // never touched here; its disabled state stays owned by the radio toggle. No-op in Control.
  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target;

      if (!form || !form.elements) {
        return;
      }

      var elements = form.elements;
      var ours = null;

      for (var i = 0; i < elements.length; i++) {
        var el = elements[i];

        if (el.classList && el.classList.contains("sc-vollbehandlung__plan")) {
          ours = el;
          break;
        }
      }

      if (!ours) {
        return;
      }

      for (var j = 0; j < elements.length; j++) {
        var control = elements[j];

        if (control !== ours && control.name === "selling_plan") {
          control.disabled = true;
        }
      }
    },
    true
  );
})();
